import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { LoginTypeSelector } from 'src/app/app-store/login/login.selector';
import { LoginType } from 'src/app/helper/constants';
import { map } from 'rxjs/operators';
import { SetRequestUrl } from 'src/app/app-store/user/user.action';

@Injectable({
  providedIn: 'root'
})
export class IsInternalUserGuard implements CanActivate {
  constructor(private store: Store, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(select(LoginTypeSelector)).pipe(
      map(result => {
        if (result === LoginType.Internal_User) {
          return true;
        } else if (result === LoginType.External_User) {
          this.store.dispatch(SetRequestUrl({ url: '/dashboard' }));
          return false;
        }
      })
    );
  }

}
